<template>
  <div class='updates-page'>

    <UpdatesForm v-if='isForm' @hideForm='hideForm' />
    <SignUpThx v-else />
    <InfoBlockSticky />
    <InfoBlock class='trigger' />
    <Footer />
  </div>
</template>

<script>
import UpdatesForm from '../components/sections/UpdatesForm'
import InfoBlock from '../components/sections/InfoBlock'
import InfoBlockSticky from '../components/sections/InfoBlockSticky'
import SignUpThx from '../components/sections/SignUpThx'
import Footer from '../components/sections/Footer'
import ogImage from '../assets/images/Jornay_OG_Image.jpg'

export default {
  name: 'Updates',
  metaInfo: {
    title: 'Sign Up | JORNAY PM® (methylphenidate HCI)',
    link: [
      {
        rel: 'canonical',
        href: 'https://www.jornaypm.com/sign-up'
      }
    ],
    meta: [
      {
        name: 'description',
        content:
          'Sign up to stay connected and receive news, announcements, and updates about JORNAY PM® (methylphenidate HCI extended-release capsules). Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:title',
        content: 'Sign Up | JORNAY PM® (methylphenidate HCI)'
      },
      {
        property: 'og:description',
        content:
          'Sign up to stay connected and receive news, announcements, and updates about JORNAY PM® (methylphenidate HCI extended-release capsules). Please see full Prescribing Information, including Boxed Warning, and Medication Guide'
      },
      {
        property: 'og:image',
        content: ogImage
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      }
    ]
  },
  components: {
    UpdatesForm,
    InfoBlock,
    InfoBlockSticky,
    SignUpThx,
    Footer
  },
  data () {
    return {
      isForm: true
    }
  },
  methods: {
    hideForm () {
      this.isForm = false
      window.scrollTo(0, 0)
    }
  },
  created () {
    if (sessionStorage.getItem('isSignUp') === 'true') {
      this.isForm = false
      sessionStorage.setItem('isSignUp', 'false')
    }
  }
}
</script>

<style lang='scss' scoped>
.updates-page {
  overflow-x: hidden;
}
</style>
